import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { blue, green, red, purple, white } from "../../../theme/colours";

const RankLegend = ({ rankRange }) => {
  const { t } = useTranslation("CompetitionInfo");
  const legendStyle = {
    width: "18rem",
    height: "8rem",
    padding: "1rem",
    background: white,
    boxShadow: "0px 2px 3px 1px #dad8e8",
    borderRadius: "12px",
    display: "flex",
    flexWrap: "wrap",
    zIndex: 1,
  };
  const titleAreaStyle = {
    width: "100%",
    mb: "1rem",
  };
  const itemAreaStyle = {
    display: "flex",
    justifyContent: "flex-start",
    width: "50%",
    height: "50%",
  };
  const bubbleStyle = {
    height: "0.75rem",
    width: "0.75rem",
    borderRadius: "25px",
    mr: "0.5rem",
  };
  const highBubble = {
    background: green[2],
  };
  const topBubble = {
    background: blue[1],
  };
  const midBubble = {
    background: purple[3],
  };
  const lowBubble = {
    background: red[1],
  };

  return (
    <Box sx={legendStyle}>
      <Box sx={titleAreaStyle}>
        <Typography variant="h3">{t("colorCoding")}</Typography>
      </Box>
      <Box sx={itemAreaStyle}>
        <Box sx={{ ...bubbleStyle, ...highBubble }} />
        <Typography variant="h4">
          {`${t("highestRank")} ${rankRange}`}
        </Typography>
      </Box>
      <Box sx={itemAreaStyle}>
        <Box sx={{ ...bubbleStyle, ...topBubble }} />
        <Typography variant="h4">{t("topThird")}</Typography>
      </Box>
      <Box sx={itemAreaStyle}>
        <Box sx={{ ...bubbleStyle, ...midBubble }} />
        <Typography variant="h4">{t("middleThird")}</Typography>
      </Box>
      <Box sx={itemAreaStyle}>
        <Box sx={{ ...bubbleStyle, ...lowBubble }} />
        <Typography variant="h4">{t("bottomThird")}</Typography>
      </Box>
    </Box>
  );
};

export default RankLegend;
